import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import LoadingBtn from '../../../../Report/LoadingBtn';
import { TransferChildRef } from '../../../Common/TransferForAddTargets/exchange';
import { useOrgStore } from '../../../../../models/useOrgModel';
import { ServiceTypeSelection } from '../ServiceTypeSelection';
import { ExchangeTarget } from '../Target/ExchangeTarget';
import { GmailTarget } from '../Target/GmailTarget';

const AddUserFromOrgModal = (props: {
  withEditPermission: boolean;
  visible: boolean;
  loading: boolean;
  onSave: (value: string[]) => void;
  setLoading: (loading: boolean) => void;
  onClose: () => void;
  onReload: () => void;
  orgId: string;
}) => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const childRef = useRef<TransferChildRef | null>(null);
  const gmailChildRef = useRef<TransferChildRef | null>(null);
  const { orgsMap, orgId } = useOrgStore();
  const onClose = () => {
    props.onClose();
  };
  const [selectedPolicyType, setSelectedPolicyType] =
    React.useState<string>('1');

  const getAllCheckedTargets = async () => {
    const checkedTargets =
      selectedPolicyType === '1'
        ? childRef.current?.checkedKeys
        : gmailChildRef.current?.checkedKeys;
    if (!checkedTargets) return [];
    const checkedKeys: string[] =
      checkedTargets &&
      checkedTargets.map(
        (item) => `${item.firstName}||${item.lastName}|${item.email}|${orgId}`
      );
    return checkedKeys;
  };

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={props.visible}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalHeader>
          {t('globalSetting.highProfileUsers.addFromOrganization.title')}
        </ModalHeader>
        <ModalBody>
          <Box>
            <Flex>
              <Text
                color={colorStyle.color.secondary}
                lineHeight="md"
                maxWidth={600}
              >
                {t('globalSetting.highProfileUsers.addFromOrganization.desc')}
              </Text>
            </Flex>
            <Box m="12px 0px">
              <Text>
                {t('common.label.currentOrganization')}:{' '}
                {`${orgsMap.get(orgId) ? orgsMap.get(orgId) : ''}`}
              </Text>
            </Box>
            <Flex m="12px 0px">
              <ServiceTypeSelection
                selectedPolicyType={selectedPolicyType}
                setSelectedPolicyType={setSelectedPolicyType}
              />
            </Flex>
            {selectedPolicyType === '1' ? (
              <ExchangeTarget ref={childRef} />
            ) : (
              <GmailTarget ref={gmailChildRef} />
            )}
          </Box>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn
            loading={false}
            onClick={async () => {
              const checkedTargets = await getAllCheckedTargets();
              props.onClose();
              await props.onSave(checkedTargets);
            }}
            variant="primary"
          >
            {t('common.button.ok')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={props.onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default React.memo(AddUserFromOrgModal);
